import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// Divider that sits above the checked items: it names the dimmed zone ("Done")
// so a first-time user understands checked ≠ deleted, and offers one-tap actions
// for everything below it. Emits 'undo' (uncheck all) and 'clear' (delete all;
// the page confirms first).
export const DoneDivider = () => {
    const base = Div()
    base.addClass(style.base)

    const label = Div('Done')
    label.addClass(style.label)

    const actions = Div()
    actions.addClass(style.actions)

    const undo = Div('Uncheck all')
    undo.addClass(style.clear)
    undo.el.onclick = (e) => {
        e.stopPropagation()
        base.emit('undo')
    }

    const clear = Div('Delete all')
    clear.addClass(style.clear)
    clear.el.onclick = (e) => {
        e.stopPropagation()
        base.emit('clear')
    }

    actions.append(undo, clear)
    base.append(label, actions)

    return Object.assign(base, {
        setCount(n: number) {
            label.text(n > 0 ? `Done · ${n}` : 'Done')
        },
    })
}
